export default class Particle {
  constructor(
    speed: number,
    xPosition: number,
    yPosition: number,
    rotation: number,
    path: string,
    canvas: HTMLCanvasElement,
    isInfinite: boolean,
  ) {
    this.speed = speed;
    this.xPosition = xPosition;
    this.yPosition = yPosition;
    this.positionCounter = 0;
    this.sign = Math.random() < 0.5 ? -1 : 1;
    this.rotation = rotation;
    this.canvas = canvas;
    this.isInfinite = isInfinite;
    this.opacity = 1;

    this.image = new Image();
    this.image.src = path;
    this.hasError = false;

    // If image loading fails and HTMLImageElement enters broken state, we do not want to
    // to execute drawImage in drawRotated method. HTMLImageElement.complete returns true
    // for images in broken state, so we add additional property in error handler.
    this.image.onerror = (): void => {
      this.hasError = true;
    };
  }

  /* eslint-disable lines-between-class-members */
  speed: number;
  xPosition: number;
  yPosition: number;
  positionCounter: number;
  rotation: number;
  sign: number;
  canvas: HTMLCanvasElement;
  isInfinite: boolean;
  opacity: number;
  image: HTMLImageElement;
  hasError?: boolean;
  /* eslint-enable lines-between-class-members */

  update(): boolean {
    const rotation = this.rotation + this.positionCounter;
    const xPosition =
      this.xPosition + Math.cos(this.positionCounter / 100) * 25;
    const yPosition = this.yPosition + Math.abs(this.positionCounter);

    const fadeOutRange = this.canvas.height / 3;

    if (yPosition > this.canvas.height - fadeOutRange) {
      const opacity = (this.canvas.height - yPosition) / (fadeOutRange * 1.25);
      this.opacity = opacity > 0 ? opacity : 0;
    }

    if (yPosition > this.canvas.height + 20) {
      if (this.isInfinite) {
        this.yPosition = -20;
        this.positionCounter = 0;
        this.opacity = 1;
      } else {
        return false;
      }
    }

    this.positionCounter += this.sign * this.speed;
    this.drawRotated(xPosition, yPosition, rotation);

    return true;
  }

  drawRotated(xPosition: number, yPosition: number, deg: number): void {
    const rad = (deg * Math.PI) / 180;
    const ctx = this.canvas.getContext('2d');

    if (ctx) {
      ctx.save();
      ctx.globalAlpha = this.opacity;
      ctx.translate(
        xPosition + this.image.width / 2,
        yPosition + this.image.height / 2,
      );
      ctx.rotate(rad);

      if (
        this.image.complete &&
        !this.hasError &&
        /**
         * INDEX_SIZE_ERR if the canvas or source rectangle width or height is zero.
         *
         * @see https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/drawImage#exceptions_thrown
         */
        this.image.width > 0 &&
        this.image.height > 0
      ) {
        ctx.drawImage(
          this.image,
          (this.image.width / 2) * -1,
          (this.image.height / 2) * -1,
          this.image.width * 2,
          this.image.height * 2,
        );
      }

      ctx.rotate(rad * -1);
      ctx.translate(
        (xPosition + this.image.width / 2) * -1,
        (yPosition + this.image.height / 2) * -1,
      );
      ctx.restore();
    }
  }
}
